const actions = {
  TOGGLE_MOBILE_ADMIN_MENU: "TOGGLE_MOBILE_ADMIN_MENU"
};
export default actions;



// WEBPACK FOOTER //
// ./src/redux/constants/admin/admin.js